module.exports = __webpack_public_path__ + "static/img/exchange_title.ee3af75b.png";